"use client";
import { cn } from "@/lib/utils";
import { SOCIAL_LINKS } from "@/lib/constants/social";
import { SOCIAL_ICONS } from "@/components/social/socialIcons";

export interface ISocialIconRowProps {
  className?: string;
  iconSize?: number;
}

export function SocialIconRow({
  className,
  iconSize = 32,
}: ISocialIconRowProps): React.ReactElement | null {
  const links = SOCIAL_LINKS.filter((link) => Boolean(link.href));
  if (links.length === 0) return null;

  return (
    <div className={cn("flex justify-start items-center gap-1", className)}>
      {links.map((link) => {
        const Icon = SOCIAL_ICONS[link.id];

        return (
          <a
            key={link.id}
            href={link.href}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={link.label}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-background/60 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-muted"
          >
            <Icon size={iconSize} />
          </a>
        );
      })}
    </div>
  );
}
